import { subDays, format } from 'date-fns'
import { useI18n } from 'vue-i18n'
import type { HistoryGroup } from '../types'

/* the chat history shown in the history popover, grouped by day; call it from a component's setup */
export function useChatHistory(): { historyItems: HistoryGroup[] } {
  const NOW = new Date()

  const { t } = useI18n()

  const historyItems: HistoryGroup[] = [
    {
      name: t('aichat.main.history.time.today'),
      items: [
        {
          prompt: 'How does today compare to last Tuesday?',
          datetime: format(NOW, 'p')
        },
        {
          prompt: 'Show me items running low on stock',
          datetime: format(NOW, 'p')
        }
      ]
    },
    {
      name: t('aichat.main.history.time.yesterday'),
      items: [
        {
          prompt: 'What sold best today?',
          datetime: format(subDays(NOW, 1), 'p')
        },
        {
          prompt: 'How do I set up a discount?',
          datetime: format(subDays(NOW, 1), 'p')
        }
      ]
    },
    {
      name: format(subDays(NOW, 2), 'PP'),
      items: [
        {
          prompt: 'Show me the shift plan for tomorrow',
          datetime: format(subDays(NOW, 2), 'p')
        },
        {
          prompt: 'Which supplier delivers oat milk?',
          datetime: format(subDays(NOW, 2), 'p')
        }
      ]
    },
    {
      name: format(subDays(NOW, 3), 'PP'),
      items: [
        {
          prompt: 'What is trending this week?',
          datetime: format(subDays(NOW, 3), 'p')
        },
        {
          prompt: 'Who worked the most hours this month?',
          datetime: format(subDays(NOW, 3), 'p')
        }
      ]
    },
    {
      name: format(subDays(NOW, 4), 'PP'),
      items: [
        {
          prompt: 'How do I change my opening hours?',
          datetime: format(subDays(NOW, 4), 'p')
        }
      ]
    },
    {
      name: format(subDays(NOW, 5), 'PP'),
      items: [
        {
          prompt: 'What has not sold in 30 days?',
          datetime: format(subDays(NOW, 5), 'p')
        }
      ]
    }
  ]

  return { historyItems }
}
